import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ReportDefinition, ReportId } from '@core/models';

@Component({
  selector: 'app-report-catalog',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './report-catalog.component.html',
  styleUrl: './report-catalog.component.scss',
})
export class ReportCatalogComponent {
  @Input({ required: true }) reports: ReportDefinition[] = [];
  @Input() loading = false;
  @Input() loadFailed = false;
  @Input() generating = false;

  @Output() retryRequested = new EventEmitter<void>();
  @Output() previewRequested = new EventEmitter<ReportId>();
  @Output() configureRequested = new EventEmitter<ReportId>();
}